import {GlobalActor, globalValue, GlobalWatch} from '@acng/frontend-relativity';
import {ARRAY, CONST, guard, INTEGER, OBJECT, STRING} from '@acng/frontend-rubicon';
import {isDefined, noop} from '@acng/frontend-bounty/std/value.js';

import {get} from '../../core/service/backend.js';
import {TIMESTAMP_MS} from '../../model';
import {ctxEventBusUser, getEventBusUser, listen} from '../../userPool/context/event-bus-user.js';
import {ctxMatches} from '../context/list.js';

const VERBOSE = false;

const EVENTBUS_MATCH = /* @__PURE__ */ OBJECT({
  type: /* @__PURE__ */ CONST('hon.matched'),
  amateur_id: INTEGER,
  timestamp_ms: TIMESTAMP_MS,
});

const MATCHES = /* @__PURE__ */ ARRAY(STRING);

/**
 * @returns {Promise<void> | void}
 */
let setup = () => {
  DEBUG: if (VERBOSE) console.warn('Setup match list.');
  const provideMatches = GlobalActor(ctxMatches);

  /**
   * @param {number} userId
   */
  const reset = async (userId) => {
    if (!userId) {
      DEBUG: if (VERBOSE) console.group('No user. Clear match list.');
      provideMatches([]);
      DEBUG: if (VERBOSE) console.groupEnd();

      return;
    }

    const url = 'hotornot/matches';

    DEBUG: if (VERBOSE) console.log('Load match list for user...', {userId});
    const list = await get(url);
    ASSERT: guard(list, MATCHES, `${url} response`);

    /**
     * Validate the current user.
     */
    const currentUser = getEventBusUser();

    if (userId == currentUser?.id) {
      DEBUG: if (VERBOSE) console.group('...provide loaded match list.', {list, currentUser});
      provideMatches(list);
      DEBUG: if (VERBOSE) console.groupEnd();
    }

    DEBUG: if (userId != currentUser?.id) {
      console.info('...drop loaded match list for previous user.', {currentUser, userId, list});
    }
  };

  setup = noop;

  GlobalWatch(ctxEventBusUser)(async (user, previous) => {
    if (isDefined(previous) && previous?.id != user?.id) {
      DEBUG: if (VERBOSE) console.info('Handle changed event bus user.', {user, previous});
      reset(user?.id ?? 0);
    }
  });

  listen('hon.matched', (data) => {
    ASSERT: guard(data, EVENTBUS_MATCH, '"hon.matched" bus event');
    const matches = globalValue(ctxMatches);
    const id = data.amateur_id.toString();

    if (data.amateur_id && !matches.includes(id)) {
      matches.unshift(id);
      provideMatches(matches);
    }
  });

  return reset(getEventBusUser()?.id ?? 0);
};

export {setup};
